<div class="image-paragraph">

  @if (loading) {
    <hpo-placeholder
    type="row"></hpo-placeholder>
  }

  @if (!loading) {
    @switch (type) {
      @case ('media--video') {
        <div class="image-paragraph__video">
          <iframe class="image-paragraph__iframe"
            [src]="source"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
          allowfullscreen></iframe>
        </div>
        <figure>
          @if (caption) {
            <figcaption>
              {{caption}}
            </figcaption>
          }
        </figure>
      }
      @case ('media--image') {
        @if (mobile) {
          <a [href]="source"
            target="_blank"
            class="image-paragraph__link">
            <figure>
              <img [src]="source"
                alt="Image"
                class="image-paragraph__image">
              @if (caption) {
                <figcaption>
                  {{caption}}
                </figcaption>
              }
            </figure>
          </a>
        }
        @if (!mobile) {
          <figure>
            <img [src]="source"
              alt="Image"
              class="image-paragraph__image"
              (click)="openZoomDialog()">
            @if (caption) {
              <figcaption>
                {{caption}}
              </figcaption>
            }
          </figure>
        }
      }
    }
  }

</div>